var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuList',{staticClass:"popup-menu-list",attrs:{"items":_vm.items,"selected-item":_vm.selectedItem,"checkbox-style":_vm.checkboxStyle}})}
var staticRenderFns = []

export { render, staticRenderFns }